<template>
	<v-sheet>
        <MwList storeModule="templates" path="templates" :columns="headers">
        </MwList>
    </v-sheet>
</template>

<script type="text/javascript">
import MwList from "@c/ui/MwList";
export default {
	name: "Templates",
    data: () => {
        return {
            filtered: false
        }
    },
	computed: {
		headers() {
			return [
				{value: "id", text: "ID", default: true},
				{value: "subject", text: "Subject", default: true},
				{value: "type", text: "Type", default: true},
			];
		},
	},
	components: {
		MwList
	},
};
//
</script>
"
